export const WEEK_STARTS_ON_MONDAY = 1;
export const WEEKDAY_LABEL_FORMAT = "EEEEEE";
export const MONTH_LABEL_FORMAT = "LLL";
export const MONTHS_IN_YEAR = 12;
export const DAYS_IN_WEEK = 7;
export const DAY_GRID_WEEKS = 6;
export const YEARS_IN_DECADE = 10;
export const DECADE_GRID_LEADING_YEARS = 2;
export const DECADE_GRID_YEARS = 16;
export const MONTH_GRID_COLUMNS = 3;
export const YEAR_GRID_COLUMNS = 4;

export type DatePanelStepDirection = -1 | 1;
